import { useEffect } from 'react';
import OtpInput from 'react-otp-input';
import { IOtpInput } from './IOtpInput';
import './otpInput.css';
import CountDown from '../countDown/countDown';

export default function CustomisedOtpInput({
    otp,
    setOtp,
    numInputs,
    otpTime,
    resendOtp,
    error
}: IOtpInput) {


    return (
        <div>
            <div dir="ltr" style={{ display: 'flex', justifyContent: 'center' }}>
                <OtpInput
                    errorStyle={{ border: '1px solid #FF617C', color: '#FF617C' }}
                    isInputNum={true}
                    value={otp}
                    onChange={setOtp}
                    numInputs={numInputs}
                    separator={<span></span>}
                    shouldAutoFocus
                    className="otpInput "
                    inputStyle={{
                        width: '2.2em',
                        height: '2.1em',
                        fontSize: '24px',
                        border: `1px solid ${error ? '#FF617C' : 'var(--header-border-color)'} `,
                        outline: 'none',
                        borderRadius: '6px',
                        name: 'otp',
                        id: 'otp',
                        margin: '0px 5px',
                        backgroundColor: `rgba(0, 0, 0, 0.08)`,
                        color: 'var(--primary-text-color)',
                    }}
                />

            </div>
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
                {otpTime && (
                    <CountDown countDownValue={otpTime} resendOtp={resendOtp} />
                )}
            </div>
        </div>
    );
}
